import { createContext } from 'react'
import type { ContextData } from './ManCodeInformationOverlay'

export const InternalManCodeOverlayContext = createContext<ContextData | undefined>(undefined)
InternalManCodeOverlayContext.displayName = 'ManCodeOverlayContext'
